module.exports = __webpack_public_path__ + "img/雪然医美（杭州）.96d4294.png";